module.exports = __webpack_public_path__ + "img/homefood-logo.8be01626.png";